module.exports = __webpack_public_path__ + "static/DashboardScreenshot-da99e2825b0566d3dda1c7912f554281.png";